export function encodeBase64(bytes: Uint8Array): string {
	return btoa(String.fromCharCode.apply(null, Array.from(bytes)));
}

export function decodeBase64(base64: string): Uint8Array {
	return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}
